export const Colors = Object.freeze({
    RED: '--custom-red',
    AMBER: '--custom-amber',
    GREEN: '--custom-green',
    BLUE: '--custom-blue',
    TEAL: '--custom-teal',
});

export const getAllColors = () => {
    return [
        { name: 'Red', value: Colors.RED },
        { name: 'Amber', value: Colors.AMBER },
        { name: 'Green', value: Colors.GREEN },
        { name: 'blue', value: Colors.BLUE },
        { name: 'teal', value: Colors.TEAL },
    ];
};

export const colorBasedOnStatus = (status) => {
    switch (status) {
        case 'No Progress':
        case 'No progress':
            return Colors.RED;
        case 'In Progress':
        case 'In progress':
            return Colors.AMBER;
        case 'Completed':
            return Colors.GREEN;
        case 'QA/Archive':
            return Colors.TEAL;
    }
};

export const colorBasedOnPriority = (priority) => {
    switch (priority) {
        case 'High':
            return Colors.RED;
        case 'Medium':
            return Colors.AMBER;
        case 'Low':
            return Colors.BLUE;
    }
};

export const colorBasedOnOutcome = (outcomeType) => {
    if (outcomeType == 'Notable Practice') {
        return Colors.RED;
    } else if (outcomeType == 'Service Wide') {
        return Colors.AMBER;
    } else {
        return Colors.BLUE;
    }
};
